
<script>
import CostTypeService from "@/store/services/costtype.service.js";
import ArchiveBase from "@/components/base_components/ArchiveBase.vue";

export default {
    name: "CostTypeArchive",
    extends: ArchiveBase,
    methods: {
        extendable(){
            let vm = this;
            this.swapState();

            let data = CostTypeService.prepareDataForUpdate(this.item);

            CostTypeService.update(data).catch(function (response) {
                vm.swapState();
                if (response.status == 403) {
                    // _showPremiumModal();
                } else {
                    console.error("Update cost type failed" + response);
                }
            });
        }
    }
};
</script>